import { getAxiosClient } from "../../axios-client";
import { AddOfferRequestBody, AddOfferResponse } from "./types";

const axiosClient = getAxiosClient();
export const addOffer = async (body: AddOfferRequestBody) => {
  return await axiosClient.ax.post<AddOfferResponse>("/Offers/OffersAdd", body);
};
